import requstHelper from './requstHelper';
import store from '../store';

class serviceApi {
    // 默认构造函数
    constructor() {
        return this;
    }

    // 获取活动列表数据
    static getZJlist = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('/content/acquisition/index/list', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'GET',
        });
    };
    // 文件上传
    static uploadImg = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('/common/stream/file/upload', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };
    // 投票
    static addVote = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        const userInfo = store.getters['user/userInfo'];
        myParams.userId = userInfo.userId;
        return requstHelper.fetch('/query/case/player/vote', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };
    // 获取活动详情信息
    static detailCL = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        const userInfo = store.getters['user/userInfo'];
        myParams.userId = userInfo ? userInfo.userId : '';
        return requstHelper.fetch('content/acquisition/info', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'GET',
        });
    };
    // 提交活动信息
    static saveCL = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        const userInfo = store.getters['user/userInfo'];
        myParams.userId = userInfo.userId;
        return requstHelper.fetch('/content/acquisition/save', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };
    // 查询首页banner列表
    static queryBannerLists = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('query/index/banner/list', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };

    /**
     * 查询资讯列表
     * @param {Object} params-请求参数
     * @param {String} params.companyCode-公司编码
     * @param {String} params.areaCode-专区编码
     * @param {String} params.modelCode-模块编码
     * @param {Number} params.pageNum-模块页码
     * @param {Number} params.pageSize-模块页数
     */
    static queryLists = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('query/article/list', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };

    /**
     * 查询收藏列表
     * @param {Object} params-请求参数
     * @param {String} params.companyCode-公司编码
     * @param {String} params.areaCode-专区编码
     * @param {Number} params.pageNum-模块页码
     * @param {Number} params.pageSize-模块页数
     * @param {String} params.userId-用户id
     */
    static queryCollectLists = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        const userInfo = store.getters['user/userInfo'];
        myParams.userId = userInfo.userId;
        return requstHelper.fetch('accounts/collection/query', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };

    /**
     * 查询文章详情
     * @param {Object} params-请求参数
     * @param {String} params.companyCode-公司编码
     * @param {String} params.areaCode-专区编码
     * @param {String} params.code-文章code
     * @param {String} params.userId-用户id
     */
    static getArticleInfo = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        const userInfo = store.getters['user/userInfo'];
        myParams.userId = userInfo ? userInfo.userId : '';
        return requstHelper.fetch('query/article/query/details', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };

    /**
     * 跳转医生站免登陆
     * @param {Object} params-请求参数
     * @param {String} params.companyCode-公司编码
     * @param {String} params.areaCode-专区编码
     * @param {String} params.userId-用户id
     */
    static densityFreeLogin = () => {
        const myParams = {};
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const userInfo = store.getters['user/userInfo'];
        myParams.userId = userInfo.userId;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt

        return requstHelper.fetch('accounts/user/densityFreeLogin', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'GET',
        });
    }

    /**
     * 获取文章评论
     * @param {Object} params-请求参数
     * @param {Number} params.pageNum-页码
     * @param {Number} params.pageSize-每页条数
     * @param {String} params.code-内容code
     * @param {String} params.companyCode-公司编码
     * @param {String} params.areaCode-专区编码
     * @param {String} params.userId-用户id
     */
    static getComments = (params) => {
        const myParams = params;
        const userInfo = store.getters['user/userInfo']; // 获取用户信息
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        if (!(encrypt)) {
            return false;
        } // 判断用户是否登录
        myParams.userId = userInfo.userId;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        return requstHelper.fetch('/query/message/list', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };

    /**
     * 回答问题
     * @param {Object[]} params-请求参数
     * @param {String} params.code-文章 视频 会议 调研唯一code
     * @param {String} params.answer-答案
     * @param {String} params.topicCode-题目编号
     */
    static answerTopic = (params) => {
        const myParams = params;
        const areaCode = process.env.AREA_CODE; // 区域号
        const companyCode = process.env.COMPANY_CODE; // 公司号
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        const userInfo = store.getters['user/userInfo']; // 获取用户信息
        myParams.userId = userInfo.userId;
        return requstHelper.fetch('query/topic/answer', myParams, {
            header: {
                encrypt: encrypt,
                companyCode: companyCode,
                areaCode: areaCode
            },
        }, true);
    };

    // 发送消息
    static sendMessage = (params) => {
        const myParams = params;
        myParams.areaCode = process.env.AREA_CODE; // 区域号
        myParams.companyCode = process.env.COMPANY_CODE; // 公司号
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        const userInfo = store.getters['user/userInfo']; // 获取用户信息
        myParams.userId = userInfo.userId;
        return requstHelper.fetch('accounts/message/add', myParams, {
            header: {
                encrypt: encrypt,
            },
        }, true);
    };

    // 添加收藏
    static addCollection = (params) => {
        const myParams = params;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        const userInfo = store.getters['user/userInfo']; // 获取用户信息
        myParams.userId = userInfo.userId;
        myParams.areaCode = process.env.AREA_CODE; // 区域号
        myParams.companyCode = process.env.COMPANY_CODE; // 公司号
        return requstHelper.fetch('accounts/collection/add', myParams, {
            header: {
                encrypt: encrypt,
            },
        }, true);
    };

    // 取消收藏
    static cancelCollection = (params) => {
        const myParams = params;
        const userInfo = store.getters['user/userInfo']; // 获取用户信息
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        myParams.areaCode = process.env.AREA_CODE; // 区域号
        myParams.companyCode = process.env.COMPANY_CODE; // 公司号
        myParams.userId = userInfo.userId || '';
        return requstHelper.fetch('accounts/collection/cancel', myParams, {
            header: {
                encrypt: encrypt,
            },
        }, true);
    };

    // 给文章点赞
    static setPraise = (params) => {
        const myParams = params;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        const userInfo = store.getters['user/userInfo']; // 获取用户信息
        myParams.areaCode = process.env.AREA_CODE; // 区域号
        myParams.companyCode = process.env.COMPANY_CODE; // 公司号
        myParams.userId = userInfo.userId || '';
        return requstHelper.fetch('common/up/great', myParams, {
            header: {
                encrypt: encrypt,
            },
        }, true);
    };

    // 上传图片
    static uploadFile = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('common/file/upload', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };

    /**
     * 调研列表
     * @param {Object[]} params-请求参数
     * @param {String} params.modelCode-模块code
     * @param {Number} params.pageNum-页码
     * @param {Number} params.pageSize-每页条数
     * @param {String} params.companyCode-公司code
     * @param {String} params.areaCode-产品code
     * @param {String} params.userId-用户ID
     */
    static getServeyList = (params) => {
        const myParams = params || {};
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        const userInfo = store.getters['user/userInfo'];
        myParams.userId = userInfo.userId;
        return requstHelper.fetch('survey/info/list', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };

    /**
     * 获取社区博客列表 ---- 2020.04.13新提供接口
     * @param {Object} params-请求参数
     * @param {String} params.modelCode-模块code
     * @param {Number} params.pageNum-页码
     * @param {Number} params.pageSize-每页条数
     * @param {Number} params.sortType-排序方式 1：时间排序  2：热度排序
     * @param {String} params.companyCode-公司code
     * @param {String} params.areaCode-产品code
     */
    static getMeetingList = (params) => {
        const myParams = params || {};
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('query/meeting/list', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };

    /**
     * 获取会议详情
     * @param {Object} params-请求参数
     * @param {String} params.companyCode-公司code
     * @param {String} params.areaCode-产品code
     * @param {String} params.userId-用户ID
     */
    static getMeetingDetail = (params) => {
        const myParams = params || {};
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const userInfo = store.getters['user/userInfo'];
        myParams.userId = userInfo.userId;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('query/meetings/code/info', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };

    /**
     * 获取病例详情
     * @param {Object} params-请求参数
     * @param {String} params.companyCode-公司code
     * @param {String} params.areaCode-产品code
     * @param {String} params.userId-用户ID
     */
    static getCaseDetail = (params) => {
        const myParams = params;
        myParams.areaCode = process.env.AREA_CODE;
        const userInfo = store.getters['user/userInfo']; // 获取encrypt
        myParams.userId = userInfo.userId;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('query/show/info', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };

    /**
     * 获取调研详情（题目列表）
     * @param {Object} params-请求参数
     * @param {String} params.code-调研code
     * @param {String} params.companyCode-公司code
     * @param {String} params.areaCode-产品code
     * @param {String} params.userId-用户ID
     */
    static getTopicList = (params) => {
        const myParams = params;
        myParams.areaCode = process.env.AREA_CODE;
        const userInfo = store.getters['user/userInfo']; // 获取encrypt
        myParams.userId = userInfo.userId;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('survey/topic/list/v2', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    };

    /**
     * 获取医生列表
     * @param {Object} params-请求参数
     * @param {String} params.companyCode-公司code
     * @param {String} params.areaCode-产品code
     * @param {String} params.doctorName-医生姓名（模糊查询）
     * @param {Number} params.pageNum-页码
     * @param {Number} params.pageSize-每页条数
     */
    static getDoctorList = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('query/binding/doctor/listInfo', myParams, {
            header: {
                encrypt: encrypt,
            },
        }, true);
    };

    /**
     * 绑定邀请关系
     * @param {Object} params-请求参数
     * @param {String} params.companyCode-公司code
     * @param {String} params.areaCode-产品code
     * @param {String} params.beInviteUid-当前用户userId
     * @param {String} params.inviteUid-代表的userIed
     */
    static inviteUidCheck = (params) => {
        const myParams = params;
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        const userInfo = store.getters['user/userInfo']; // 获取encrypt
        myParams.beInviteUid = userInfo.userId;
        myParams.inviteUid = store.getters['user/inviteUid']; // 邀请码
        return requstHelper.fetch('accounts/user/invite/save', myParams, {
            header: {
                encrypt: encrypt,
            },
        });
    };

    /**
     * 外链上报
     * @param {Object} params-请求参数
     * @param {String} params.companyCode-公司code
     * @param {String} params.areaCode-产品code
     * @param {String} params.url-外链url
     * @param {Number} params.type-社区播客外链上报传4
     */
    static linkSave = (params) => {
        const myParams = params || {};
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('common/report/pv/add', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    }

    /**
     * 获取推荐之星数据
     * @param {Object} params-请求参数
     * @param {String} params.companyCode-公司code
     * @param {String} params.areaCode-产品code
     * @param {String} params.type-1：月榜  2：总榜
     */
    static getStarList = (params) => {
        const myParams = params || {};
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('accounts/styy/recommend/star', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    }

    // 调研弹窗
    static surveyPop = (params) => {
        const myParams = params || {};
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('survey/pop/info', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    }

    // 我的调研列表
    static mySurvey = (params) => {
        const myParams = params || {};
        myParams.companyCode = process.env.COMPANY_CODE;
        myParams.areaCode = process.env.AREA_CODE;
        const encrypt = store.getters['user/encrypt']; // 获取encrypt
        return requstHelper.fetch('survey/userAnswer/list', myParams, {
            header: {
                encrypt: encrypt,
            },
            method: 'POST',
        });
    }





    // 转换key值，部分接口不支持json 
    static stringify = (param) => {
        const query = [];
        Object.keys(param).forEach((key) => {
            query.push(`${key}=${param[key]}`);
        });
        return query.join('&');
    }
}

export default serviceApi;


// WEBPACK FOOTER //
// ./src/api/serviceAPI.js